module.exports = __webpack_public_path__ + "html/changelog.template.html";